import React, { useEffect, useState } from 'react';
import {Select} from 'antd';
import {useContas} from './useContas';

const conjuntoContas = new Map();

const SelectContaForm = (props) => {

    const {onChange, getApi, getValueAs, initialValue=""} = props;

    const [contas, setContas] = useState([]);
    const {listaContas} = useContas(getApi);
    

    const executeListaContas = async () => {
        const result = await listaContas();
        const {data} = result;
        const contas = data.map(conta => {
            console.log("conta ===>", conta)
            conjuntoContas.set(conta.id + "", conta);
            return {value: conta.id, label: conta.nome}
        });
        setContas(contas);
    }

    useEffect(()=>{
        executeListaContas();
    }, [])
    const changeHandler = function(evt){
        if(getValueAs && getValueAs == object){
            const conta = conjuntoContas.get(evt + "");
            onChange && onChange(conta);
        } else {
            onChange && onChange(evt);
        }
        
    }

    console.log("initial value", initialValue)

    return <Select 
                defaultValue={initialValue}
                options={contas}
                onChange={changeHandler}>
        
    </Select>
}

export {SelectContaForm};


